<template>
  <form novalidate @submit.prevent="next">
    <header class="modal-header">What was the quality issue you experienced?</header>
    <section class="modal-body">
      <LsRadios
        v-model="reason"
        :validation="{ required: true }"
        name="reason"
        :options="options"
        track-id="return_request_quality_issue-reason"
        columns
      />
    </section>
    <footer class="modal-footer">
      <LsButton
        type="submit"
        text="Next"
        track-id="return_request_quality_issue-next"
        :loading="dispute.loadingStatus.isUpdating"
      />
    </footer>
  </form>
</template>

<script>
import { LsButton, LsRadios } from '@/components/common';
import { mapActions, mapState } from 'vuex';
import { DISPUTE__UPDATE_CURRENT_DISPUTE } from '@/store/types';

export default {
  name: 'ReturnRequestQualityIssue',
  components: {
    LsButton,
    LsRadios,
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      reason: '',
      options: [
        {
          label: 'Uneven mow',
          value: 'grass.uneven',
        },
        {
          label: 'Issue blowing',
          value: 'blowing',
        },
        {
          label: 'Missed spots',
          value: 'missedspots',
        },
        {
          label: 'Grass too long',
          value: 'grass.long',
        },
        {
          label: 'Bad edging',
          value: 'edging',
        },
        {
          label: 'Other',
          value: 'other',
        },
      ],
    };
  },
  computed: {
    ...mapState(['dispute']),
  },
  methods: {
    ...mapActions([DISPUTE__UPDATE_CURRENT_DISPUTE]),

    async next() {
      const valid = await this.$validator.validateAll();

      if (!valid) {
        return;
      }

      this[DISPUTE__UPDATE_CURRENT_DISPUTE]({
        reason: this.reason,
        currentStep: 'ReturnRequestLocation',
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
